import { Controller } from "@hotwired/stimulus"
import L from "leaflet"

export default class extends Controller {
  static values = {
    apiKey: String
  }

  static targets = [ "mapContainer" ]

  async connect() {
    this.map = L.map(this.mapContainerTarget, {
      minZoom: 2,
      maxZoom: 8,
      worldCopyJump: true
    })

    L.tileLayer(
      `https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png?key=${this.apiKeyValue}`,
      {
        attribution: "&copy; OpenStreetMap contributors &copy; CARTO"
      }
    ).addTo(this.map)

    this.map.fitWorld()

    await this.loadLocations()
  }

  disconnect() {
    this.map?.remove()
  }

  async loadLocations() {
    const response = await fetch("/diaspora.json")

    if (!response.ok) {
      throw new Error("Failed to load locations")
    }

    const locations = await response.json()

    locations.forEach((location) => {
      this.addLocation(location)
    })
  }

  addLocation(location) {
    const radius = 10 + Math.sqrt(location.users_count) * 3

    const marker = L.circleMarker(
      [location.latitude, location.longitude],
      {
        radius,
        fillColor: location.country_code === "GH" ? "#1d4ed8" : "#3b82f6",
        weight: 2,
        fillOpacity: 0.8
      }
    ).addTo(this.map)

    marker.on("click", () => {
      this.openPanel(location.id)
    })
  }

  openPanel(locationId) {
    const link = document.createElement("a")

    link.href = `/diaspora/${locationId}`
    link.dataset.turboFrame = "panel"

    document.body.appendChild(link)
    link.click()
    link.remove()
  }

  closePanel() {
    const panel = document.getElementById("panel")

    if (!panel) return

    panel.innerHTML = ""
  }
}